/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 获取慢必赔配置 的 **请求配置**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SlowCompensation/getCompensationSettings`
 */
const postGetCompensationSettingsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SlowCompensation/getCompensationSettings",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetCompensationSettings",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取慢必赔配置 的 **请求函数**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SlowCompensation/getCompensationSettings`
 */
export const postGetCompensationSettings = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetCompensationSettingsRequestConfig, requestData),
    ...args
  );
};
postGetCompensationSettings.requestConfig =
  postGetCompensationSettingsRequestConfig;
/**
 * 接口 设置慢必赔配置 的 **请求配置**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SlowCompensation/setCompensationSettings`
 */
const postSetCompensationSettingsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SlowCompensation/setCompensationSettings",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetCompensationSettings",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置慢必赔配置 的 **请求函数**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SlowCompensation/setCompensationSettings`
 */
export const postSetCompensationSettings = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSetCompensationSettingsRequestConfig, requestData),
    ...args
  );
};
postSetCompensationSettings.requestConfig =
  postSetCompensationSettingsRequestConfig;
/**
 * 接口 慢必赔赔付设置日志 的 **请求配置**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SlowCompensation/getCompensationSettingsLog`
 */
const postGetCompensationSettingsLogRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SlowCompensation/getCompensationSettingsLog",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetCompensationSettingsLog",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 慢必赔赔付设置日志 的 **请求函数**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SlowCompensation/getCompensationSettingsLog`
 */
export const postGetCompensationSettingsLog = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetCompensationSettingsLogRequestConfig, requestData),
    ...args
  );
};
postGetCompensationSettingsLog.requestConfig =
  postGetCompensationSettingsLogRequestConfig;
/**
 * 接口 赔付单作废操作 的 **请求配置**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SlowCompensation/cancelById`
 */
const postCancelByIdRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SlowCompensation/cancelById",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postCancelById",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 赔付单作废操作 的 **请求函数**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SlowCompensation/cancelById`
 */
export const postCancelById = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postCancelByIdRequestConfig, requestData), ...args);
};
postCancelById.requestConfig = postCancelByIdRequestConfig;
/**
 * 接口 慢必赔列表 的 **请求配置**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SlowCompensation/getSlowCompensationList`
 */
const postGetSlowCompensationListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SlowCompensation/getSlowCompensationList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetSlowCompensationList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 慢必赔列表 的 **请求函数**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SlowCompensation/getSlowCompensationList`
 */
export const postGetSlowCompensationList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetSlowCompensationListRequestConfig, requestData),
    ...args
  );
};
postGetSlowCompensationList.requestConfig =
  postGetSlowCompensationListRequestConfig;
/**
 * 接口 慢必赔列表 -  导出 的 **请求配置**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SlowCompensation/exportSlowCompensationList`
 */
const postExportSlowCompensationListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SlowCompensation/exportSlowCompensationList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportSlowCompensationList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 慢必赔列表 -  导出 的 **请求函数**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SlowCompensation/exportSlowCompensationList`
 */
export const postExportSlowCompensationList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportSlowCompensationListRequestConfig, requestData),
    ...args
  );
};
postExportSlowCompensationList.requestConfig =
  postExportSlowCompensationListRequestConfig;
/**
 * 接口 慢必赔列表 - 商品明细导出 的 **请求配置**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SlowCompensation/exportSlowCompensationDetail`
 */
const postExportSlowCompensationDetailRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SlowCompensation/exportSlowCompensationDetail",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportSlowCompensationDetail",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 慢必赔列表 - 商品明细导出 的 **请求函数**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SlowCompensation/exportSlowCompensationDetail`
 */
export const postExportSlowCompensationDetail = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportSlowCompensationDetailRequestConfig, requestData),
    ...args
  );
};
postExportSlowCompensationDetail.requestConfig =
  postExportSlowCompensationDetailRequestConfig;
/**
 * 接口 赔付单详情 的 **请求配置**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SlowCompensation/getInfoData`
 */
const postGetInfoDataRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SlowCompensation/getInfoData",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetInfoData",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 赔付单详情 的 **请求函数**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SlowCompensation/getInfoData`
 */
export const postGetInfoData = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetInfoDataRequestConfig, requestData), ...args);
};
postGetInfoData.requestConfig = postGetInfoDataRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/slowCompensation.js